import cx from 'classnames'

export const ModalBody = ({ children, className, ...props }) => <div className={cx('tw:overflow-y-auto tw:px-5 tw:py-4', className)} {...props}>{children}</div>
